var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.imageUrl)?_c('figure',{style:(_vm.style)},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":_vm.altText}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }